export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/fiverr-choice-icon.f768f0e.svg";